import React, { createContext, useContext, useEffect, useState } from "react"

type EmbedContextType = {
  isEmbed: boolean
}

const EmbedContext = createContext<EmbedContextType | undefined>(undefined)

export function EmbedProvider({ children }: { children: React.ReactNode }) {
  const [isEmbed, setIsEmbed] = useState(() => {
    // Kunin ang initial value mula sa URL
    const params = new URLSearchParams(window.location.search)
    return params.get("embed") === "true"
  })

  useEffect(() => {
    // Function to update state based on current URL
    const checkEmbed = () => {
      const params = new URLSearchParams(window.location.search)
      const newValue = params.get("embed") === "true"
      setIsEmbed(newValue)
      console.log("isEmbed updated:", newValue) // Debugging
    }

    // Run on mount and when URL changes (e.g., back/forward)
    checkEmbed()

    // Listen for popstate (back/forward navigation)
    window.addEventListener("popstate", checkEmbed)

    // Optional: Listen for history pushState/replaceState if needed
    // (but popstate covers back/forward)

    return () => {
      window.removeEventListener("popstate", checkEmbed)
    }
  }, []) // Empty dependency array – runs once and sets up listener

  return (
    <EmbedContext.Provider value={{ isEmbed }}>
      {children}
    </EmbedContext.Provider>
  )
}

export function useEmbed() {
  const context = useContext(EmbedContext)
  if (context === undefined) {
    throw new Error("useEmbed must be used within an EmbedProvider")
  }
  return context
}
